import Q from 'q';
import usStatesTopo from 'json/usStatesTopo.json';
import * as topojson from 'topojson-client';

(function(d3, NRELMT) {

  var $self = this;
  $self.Coalitions           = $self.Coalitions           || {};
  $self.Coalitions.locations = $self.Coalitions.locations || {};

  $self.Coalitions.locations.map = (function() {
    var pub = {};

    // eh, figure out better places for some of these
    var width = 1076,
        height = 500,
        projection,
        path,
        svg,
        coalitionsDataRaw,
        coalitionData,
        COALITION_OMITS = ['southwest-connecticut', 'new-haven'];

    pub.init = function() {
      coalitionData = new NRELMT.FeatureCollection(CC.Coalitions.locations.data);
      projection = d3.geo.albersUsa()
        .scale(1000)
        .translate([width / 2, height / 2]);

      path = d3.geo.path()
        .projection(projection);

      svg = d3.select('#cc-coalition-locations-map').append('svg')
        .attr('width', width)
        .attr('height', height);

      CC.utils.updateSpinner({svg:svg, loading:[1], width:width, height:height});
      _renderMap();
    };

    function _addEventListeners() {
      d3.select(self.frameElement).style('height', height + 'px');

      d3.selectAll('.cc-item')
        .on('mouseover', _onCoalitionMouseover)
        .on('mouseout', _onCoalitionMouseout)
        .on('click', _onCoalitionClick);
    }

    function _renderMap() {
      _fetchStateData()
        .then(function(res) {
          var deferred = Q.defer(); //eh, keeping the chain
          _drawStates(res);
          deferred.resolve();
          return deferred.promise;
        })
        .then(_fetchCoalitionData)
          .then(function(res){
            _drawCities(res);
            _addEventListeners();
            CC.utils.updateSpinner({svg:svg, loading:[], width:width, height:height});
          });
    }

    function _fetchStateData() {
      var deferred = Q.defer();
      deferred.resolve(usStatesTopo);
      return deferred.promise;
    }

    function _fetchCoalitionData() {
      var deferred = Q.defer();
      d3.json('/api/v1/coalitions/geojson?simplified=true', function(err, res) {
        if(err) { deferred.reject(err); }
        deferred.resolve(res.result);
      });
      return deferred.promise;
    }

    function _drawStates(res) {
      NRELMT.Render.states({
        svgEl: svg,
        path: path,
        data: topojson.feature(res, res.objects.usStates5m).features
      });
    }

    function _getShapes(shapes) {
      var retVal;
      retVal = shapes.reduce(function(arr, shape) {
        if(_.includes(COALITION_OMITS, shape.properties.short_name)) {
          // omit shapes for coalitions not shown
        } else {
          arr.push(shape);
        }
        return arr;
      }, []);
      return retVal;
    }

    function _getPoints(features, shapes) {
      var retVal;
      retVal = features.reduce(function(arr, point) {
        if(_.includes(COALITION_OMITS, point.properties.short_name)) {
          // omit points for coalitions not shown
        } else {
          point.properties.centroid = path.centroid(_.find(shapes, {properties:{id:point.properties.id}}));
          // move the centroid for Piedmont and Coastal North Carolina Clean Communities
          // because it overlaps with Triangle Clean Cities
          if (point.properties.id === 130) {
            point.properties.centroid = [804, 285];
          }
          arr.push(point);
        }
        return arr;
      }, []);
      return retVal;
    }

    function _drawCities(res) {
      var shapes = _getShapes(res.shapes.features),
          points = _getPoints(res.points.features, shapes);

      points = CC.utils.addRenderingData(points, {
        path: path,
        featureCollection: coalitionData
      }, [CC.utils.addOverrideData, CC.utils.addTextTransformData]);

      //TODO: be more clever
      coalitionsDataRaw = res;

      _renderBoundaries(shapes);
      _renderPoints(points);
      _renderLabelBoxes(points);
      _renderLabels(points);
      d3.selectAll('.cc-item').classed('active', true);
    }

    function _renderBoundaries(shapes) {
      svg.selectAll('.cc-boundaries')
          .data(shapes)
          .enter().append('path')
          .attr('class', function(d) {
            return 'cc-boundaries '+ 'cc-item cc-item-'+_getId(d) + (d.properties.apprentice ? ' apprentice' : '');
          })
          .attr('d', path);
    }

    function _renderPoints(points) {
      svg.selectAll('.cc-centerpoint')
        .data(points)
        .enter()
        .append('circle')
        .attr('cx', function(d) {return d.properties.centroid[0];})
        .attr('cy', function(d) {return d.properties.centroid[1];})
        .attr('r', 2.5)
        .attr('class', function(d) {
          return 'centerPoint cc-centerpoint cc-item cc-item-' + _getId(d) + (d.properties.apprentice ? ' cc-apprentice' : '');
        });
    }

    function _renderLabelBoxes(points) {
      svg.selectAll('.cc-label-box')
        .data(points)
        .enter().append('rect')
          .attr('height', 30)
          .attr('class', function(d) {
            return 'hidden cc-label-box active cc-item cc-item-'+_getId(d);
          })
          .attr('transform', function(d) {return d.properties.textTransformBox;})
          .style('fill', '#666');
    }

    function _renderLabels(points) {
      svg.selectAll('.cc-label')
        .data(points)
        .enter().append('text')
          .attr('class', function(d) {
            return 'hidden cc-label active cc-item cc-item-'+_getId(d);
          })
          .attr('transform', function(d) {return d.properties.textTransform;})
          .style('fill', '#fff')
          .text(function(d) {
            var id = _getId(d);
            if (d.properties.location_point_label === 'Connecticut') {
              return 'Connecticut Clean Cities Collaborative';
            } else if (d.properties.short_name === 'piedmont') {
              return 'Piedmont and Coastal North Carolina';
            } else if (d.properties.short_name === 'albany') {
              return 'Capital District Clean Communities (Albany)';
            } else {
              return d.properties.name;
            }
          });
    }

    function _onCoalitionMouseover(d) {
      var id = _getId(d);
      d3.selectAll('.cc-label, .cc-label-box').classed('hidden', true);
      d3.selectAll('.cc-label.cc-item-'+id+', .cc-label-box.cc-item-'+id).classed('hidden', false);
      var labelWidth = d3.select('.cc-label.cc-item-'+id).node().getBBox().width;
      d3.select('.cc-label-box.cc-item-'+id).attr('width', labelWidth + 20);
      d3.selectAll('.cc-item').classed('active', false);
      d3.selectAll('.cc-item-'+id).classed('active', true);
    }

    function _onCoalitionMouseout(d) {
      d3.selectAll('.cc-label, .cc-label-box').classed('hidden', true);
      d3.selectAll('.cc-item').classed('active', true);
    }

    function _onCoalitionClick(d) {
      if (!d.properties.short_name) { return; }
      if (!d.properties.location_point_label) { return; }

      if (d.properties.location_point_label === 'Connecticut') {
        window.location.href = window.location.protocol + '//' + window.location.host + '/coalitions/search?search_for=Connecticut';
      } else {
        window.location.href = window.location.protocol + '//' + window.location.host + '/coalitions/' + d.properties.short_name;
      }
    }

    function _getId(d) {
      var id;
      if (_.isArray(d)) {
        if (d[2].length === 1) {
          id = coalitionsDataRaw.points.features[d[2][0][2]].properties.id;
        }
      } else {
        id = d.properties.id;
      }
      return id;
    }

    return pub;
  })();

}).call(CC, d3, NRELMT);
